module.exports = __webpack_public_path__ + "img/googleplay.e6e8fb9c.png";